import React, {useEffect, useState} from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Tooltip,
    IconButton,
    Typography, Button, Fab,
} from "@mui/material";
import {MessageCircleMore, MessagesSquare} from "lucide-react";
import {useTranslation} from "react-i18next";
import ChatButton from "./ChatButton";
import axios from "axios";
import {defaultVariables} from "../../../config";
import Badge from "@mui/material/Badge";
import {Close} from "@mui/icons-material";
import ChatScreen from "./ChatScreen";
import AppCardLoaderFields from "../../components/loaders/AppCardLoaderFields";
import Grid from "@mui/material/Grid2";
import SubTitle from "../../components/elements/SubTitle";
import ChatViewer from "./ChatViewer";

const ChatsHistory = ({order}) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [history, setHistory] = useState([]);
    const loginToken = localStorage.getItem("ACT");
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`,
        }
    }
    const loadData = () =>{
        axios.get(`${defaultVariables.url}/messages/history/${order.id}`,config)
            .then(response => {
                setHistory(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
            });
    }
    useEffect(() => {
        if(!!open){
            loadData();
        }
    },[open]);

    const toggleOpen = () => {
        setOpen((prev) => !prev);
    }
    return (
        <>
            <Button
                color="primary"
                onClick={toggleOpen}
                startIcon={<MessageCircleMore/>}
            >
                {t('chatsHistory')}
            </Button>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={toggleOpen}
                open={open}
            >
                <DialogTitle>
                    {t('chatsHistory')}
                    <IconButton
                        onClick={() => toggleOpen()}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {
                        !!loading ?
                            <AppCardLoaderFields/>
                            :
                            <Grid container spacing={2}>
                                {
                                    !!history['user_supplier'].length &&
                                    <Grid item size={12}>
                                        <SubTitle align="left">
                                            <strong>
                                                {t('user_supplier_chats')}
                                            </strong>
                                        </SubTitle>
                                        <ChatViewer messages={history['user_supplier']} />
                                    </Grid>
                                }
                                {
                                    !!history['user_courier'].length &&
                                    <Grid item size={12}>
                                        <SubTitle align="left">
                                            <strong>
                                                {t('user_courier_chats')}
                                            </strong>
                                        </SubTitle>
                                        <ChatViewer messages={history['user_courier']} />
                                    </Grid>
                                }
                                {
                                    !!history['courier_supplier'].length &&
                                    <Grid item size={12}>
                                        <SubTitle align="left">
                                            <strong>
                                                {t('courier_supplier_chats')}
                                            </strong>
                                        </SubTitle>

                                        <ChatViewer messages={history['courier_supplier']} />
                                    </Grid>
                                }
                                {
                                    !!history['admin_supplier'].length &&
                                    <Grid item size={12}>
                                        <SubTitle align="left">
                                            <strong>
                                                {t('admin_supplier_chats')}
                                            </strong>
                                        </SubTitle>

                                        <ChatViewer messages={history['admin_supplier']} />
                                    </Grid>
                                }
                                {
                                    !!history['admin_user'].length &&
                                    <Grid item size={12}>
                                        <SubTitle align="left">
                                            <strong>
                                                {t('admin_user_chats')}
                                            </strong>
                                        </SubTitle>

                                        <ChatViewer messages={history['admin_user']} />
                                    </Grid>
                                }
                                {
                                    !!history['admin_courier'].length &&
                                    <Grid item size={12}>
                                        <SubTitle align="left">
                                            <strong>
                                                {t('admin_courier_chats')}
                                            </strong>
                                        </SubTitle>

                                        <ChatViewer messages={history['admin_courier']} />
                                    </Grid>
                                }
                                {
                                    (
                                        !history['courier_supplier'].length &&
                                        !history['user_courier'].length &&
                                        !history['user_supplier'].length &&
                                        !history['admin_supplier'].length &&
                                        !history['admin_courier'].length &&
                                        !history['admin_user'].length
                                    ) &&
                                    <Typography>{t('noHistoryChatAvailable')}</Typography>
                                }
                            </Grid>
                    }
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ChatsHistory;
